import React from 'react';
var SubNavHeader = function (_a) {
    var items = _a.items, selected = _a.selected, click = _a.click;
    return (React.createElement("div", { className: "subNavHeader" }, items.map(function (item) { return (React.createElement("div", { key: item.type, className: "subNavItem ".concat(selected === item.type ? 'selected' : ''), onClick: function () { return click(item.type); } },
        item.label,
        " ")); })));
};
export default SubNavHeader;
